export interface SectionCompletion {
  sectionId: string;
  toScroll: number;
  maxScore: number;
  progress: {
    completion: number;
    scroll: number;
    page: number;
  };
  interactions: SectionInteraction[];
}

export interface SectionInteraction {
  id: string;
  title: string;
  type: string;
  completed: boolean;
  items: { [id: string]: boolean };
}

export interface SectionProgressInterface {
  findOrCreate(sectionId: string): Promise<SectionCompletion>;
  load(sectionIds: string[]): Promise<void>;
  find(sectionId: string): SectionCompletion|null;
  saveInteraction(
    sectionId: string,
    interaction: any|null,
    scrolledPercent: number|null,
    page: number|null
  ): Promise<void>;
  createInteractionId(type: string, id: string): string;
}

export const SectionProgressSymbol = Symbol.for('SectionProgress');
